import { Directive } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * This directive implements a no-operation value accessor. Which means that components
 * adotted with it are valid custom reactive form controls, but do not actually implement
 * the interface. Rather, they can dispatch their own form control to an underlying
 * component.
 */
@Directive({
  selector: '[noopVac]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NoopValueAccessorDirective,
    },
  ],
})
export class NoopValueAccessorDirective implements ControlValueAccessor {
  writeValue(): void {
    /** noop **/
  }
  registerOnChange(): void {
    /** noop **/
  }
  registerOnTouched(): void {
    /** noop **/
  }
}
